import {
  Alert,
  AlertIcon,
  Button,
  CloseButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  AlertTitle,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { REQUEST_DELETE_MASTER_LINK } from "../../store/linkMaster/linkActionTypes";
import { useLinksMaster } from "../../store/linkMaster/reducer";
interface Props {
  link: Record<string, any>;
  isOpen: any;
  onClose: any;
}
const LinkDeleteConfirmation: React.FC<Props> = ({ link, isOpen, onClose }) => {
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const { masterLinks: links, busy, message } = useLinksMaster();
  const { _id } = link;
  useEffect(() => {
    const findLink = links.find((val: Record<string, any>) => val._id === _id);
    if (!findLink) {
      onClose();
    }
  }, [_id, links, onClose]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false} id="deleteSection">
      <ModalOverlay />
      <ModalContent >
        <ModalHeader>Delete Link</ModalHeader>
        <ModalCloseButton disabled={busy} />
        <ModalBody>
          <Text fontWeight="bold" mb="1rem">
            Are you sure to delete? {link.title}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" mr={3} onClick={onClose} disabled={busy}>
            Close
          </Button>
          <Button
            colorScheme="red"
            variant={"outline"}
            mr={3}
            disabled={busy}
            onClick={() => {
              dispatch({
                type: REQUEST_DELETE_MASTER_LINK,
                payload: { _id: link._id },
                onSuccess: () => {
                  navigate("../");
                },
              });
            }}
          >
            Submit
          </Button>
        </ModalFooter>
        {message && (
          <ModalFooter>
            <Alert status="error">
              <AlertIcon />
              <AlertTitle mr={2}>{message}</AlertTitle>
              <CloseButton position="absolute" right="8px" top="8px" />
            </Alert>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};

export default LinkDeleteConfirmation;
